import * as ng from 'angular';

import {IAppConstants} from './app.constants';
import {rabbitMQ} from './third/rabbitMQ';
import {googleAPI} from './third/googleAPI';
import {ArchiSmallERRORS} from './commons/errors';
import {DocumentStatus} from './commons/document-status';
import {ArchiSmallServices} from './services/archismall.service';
import {FileService} from './services/file.service';
import {AlertService} from './services/ui/alert.service';
import {FormService} from './services/ui/form.service';
import {saveAs} from './third/fileSaver';
import {STORAGE_BUCKET} from './config';
import {appContext} from './app.context';
import {diff} from 'deep-object-diff';


declare var document: any;

export class AppController implements ng.IController {

  static $inject: string[] = [
    '$rootScope',
    '$scope',
    '$state',
    'store',
    'jwtHelper',
    'configuration',
    'ArchiSmallServices',
    'FileService',
    'AlertService',
    'FormService',
    '$uibModal',
    '$timeout',
    '$location',
    '$interval'
  ];

  constructor(
    private $rootScope: any, // ng.IRootScopeService,
    private $scope: any, // ng.IScope,
    private $state: ng.ui.IStateService, // ng.ui.IStateService,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: ng.jwt.IJwtHelper,
    private configuration: IAppConstants,
    private ArchiSmallServices: ArchiSmallServices,
    private fileService: FileService,
    private alertService: AlertService,
    private formService: FormService,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private $timeout: ng.ITimeoutService,
    private $location: ng.ILocationService,
    private $interval: ng.IIntervalService,
  ) {
    /* global window: any, document:any */
    $scope.safeApply = (fn: Function) => {
      let phase = this.$scope.$root.$$phase;
      if (phase === '$apply' || phase === '$digest') {
        if (fn) {
          fn();
        }
      } else {
        $scope.$apply(fn);
      }
    };
    $scope.archiSmallAppVersion = configuration.archiSmallAppVersion;
    $rootScope.conservazioneNotification = {};
    $rootScope.domain = $location.host();

    $rootScope.endsWith = (str, suffix) => {
      return str.indexOf(suffix, str.length - suffix.length) !== -1;
    };

    $rootScope.archiviaUploadInProgress = false;
    $rootScope.elaborationBucket = STORAGE_BUCKET;
    $rootScope.subscriptionCancelled = false;
    $rootScope.userTypes = ['', 'archismall', 'odin'];

    $rootScope.canShowMaintenanceAlert = () => {
      $rootScope.showAlert = true;
      const storeValue = store.get('showAlert');

      if (storeValue !== undefined && storeValue !== null) {
        $rootScope.showAlert = storeValue;
      }
      // console.log($rootScope.showAlert);
      return $rootScope.showAlert;
    };

    $rootScope.dateFormat = 'dd/MM/yyyy';
    $rootScope.dateAndTimeFormat = 'dd/MM/yyyy HH:mm';
    $rootScope.loading = false;
    $rootScope.clearCache = () => {
      history.go(0);
    };
    $rootScope.loadScript = (url, type?, charset?) => {
      if (!type) {
        type = 'text/javascript';
      }
      if (url) {
        let script = document.querySelector(`script[src*='${url}']`);
        if (!script) {
          let heads = document.getElementsByTagName('head');
          if (heads && heads.length) {
            let head = heads[0];
            if (head) {
              script = document.createElement('script');
              script.setAttribute('src', url);
              script.setAttribute('type', type);
              if (charset) {
                script.setAttribute('charset', charset);
              }
              head.appendChild(script);
            }
          }
        }
        return script;
      }
    };
    $rootScope.formatDateValue = (dateValue) => {
      return new Date(dateValue);
    };
    $rootScope.formatStringAsDate = (date) => {
      if (typeof date === 'string') {
        let dateItems = date.split('/');
        let dateObj = new Date(
          +dateItems[2],
          (+dateItems[1] - 1),
          +dateItems[0]);
        return dateObj;
      }
    };

    $rootScope.getMillisecondsFromDays = (daysNumber) => {
      return daysNumber * 24 * 60 * 60 * 1000;
    };

    /*
     * method set the textarea height to not use the vertical scroll
     * It can be callded as:
     *  ng-keyup="autoExpand($event)" - for one textarea
     *  or $rootScope.autoExpand('auto-height') - for all textarea with class auto-height
     */
    $rootScope.autoExpand = (e) => {
      if (typeof e === 'object') {
        let element = e.target;
        // scrollHeight -don't work when deleting the content, textLength - not ok in px
        let scrollHeight = element.scrollHeight;
        element.style.height = scrollHeight + 'px';
      } else {
        let listElements: HTMLCollectionOf<any> = document.getElementsByClassName(e);
        for (let i = 0; i < listElements.length; i++) {
          listElements[i].style.height = '22px';
        }
        $timeout(() => {
          for (let i = 0; i < listElements.length; i++) {
            let scrollHeight = listElements[i].scrollHeight;
            listElements[i].style.height = scrollHeight + 'px';
          }
        }, 1000);
      }
    };

    $rootScope.downloadFile = (url, downloadedFileName) => {
      this.fileService.downloadFile(url);
    };

    $rootScope.downloadTDocFile = (item, type) => {
      this.fileService.downloadTDocFile(item, type);
    };

    $rootScope.generateGoogleAPIToken = () => {
      let promise = ArchiSmallServices.getGoogleAPIToken()
        .then((response: any) => {
          googleAPI.setAccessToken(response.accessToken);
          let googleAPIToken = googleAPI.getAccessToken();
        }, (error) => {
          $rootScope.alert('error', error);
        });
      return promise;
    };
    $rootScope.validateGoogleAPIToken = (token) => {
      let promise = ArchiSmallServices.validateGoogleAPIToken(token)
        .then((response) => {
          return response;
        });

      return promise;
    };

    $rootScope.audit = (settings, successCallback, errorCallback) => {

      ArchiSmallServices.audit(settings)
        .then((response) => {
          if (successCallback) {
            successCallback();
          }
        }, (error) => {
          if (errorCallback) {
            errorCallback();
          }
        });
    };
    $rootScope.downloadFileContent = (url, readType, callback, callbackParameters) => {
      let callbackParametersInstance = callbackParameters || '';
      let urlVal = url;
      let readTypeVal = readType;
      let download = (googleAPIToken, urlVal, readTypeVal, callbackParametersInstanceValue) => {
        let xhr = new XMLHttpRequest();
        xhr.open('GET', `https://storage.googleapis.com/${urlVal}`, true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + googleAPIToken);
        xhr.responseType = 'blob';
        xhr.onreadystatechange = () => {
          if (xhr.readyState === 4) {
            let reader = new FileReader();
            switch (readTypeVal) {
              case 'readAsText':
                reader.readAsText(xhr.response);
                break;
              case 'readAsDataURL':
                reader.readAsDataURL(xhr.response);
                break;
              default:
            }

            reader.onloadend = () => {
              if (callbackParametersInstanceValue !== '') {
                callback(reader.result, callbackParametersInstanceValue);
              } else {
                callback(reader.result);
              }
            };
          }
        };
        xhr.send(null);
      };
      ArchiSmallServices.validateGoogleAPIToken(googleAPI.getAccessToken())
        .then((response) => {
          let googleAPIToken = googleAPI.getAccessToken();
          download(googleAPIToken, urlVal, readTypeVal, callbackParametersInstance);
        }, (error) => {
          ArchiSmallServices.getGoogleAPIToken()
            .then((response: any) => {
              googleAPI.setAccessToken(response.accessToken);
              let googleAPIToken = googleAPI.getAccessToken();
              download(googleAPIToken, urlVal, readTypeVal, callbackParametersInstance);
            }, (error) => {
              $rootScope.alert('error', error);
            });
        });
    };
    $rootScope.guid = () => {
      let s4 = () => {
        return Math.floor((1 + Math.random()) * 0x10000)
          .toString(16)
          .substring(1);
      };
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
        s4() + '-' + s4() + s4() + s4();
    };

    $rootScope.checkIfArchiveExists = (userNotificationArchive, archiveName) => {
      return $rootScope[archiveName].some((archive) => {
        return archive._id === userNotificationArchive._id;
      });
    };

    $rootScope.addArchive = (userNotificationArchive, archiveName) => {
      $rootScope.$apply(() => {
        $rootScope[archiveName].unshift(userNotificationArchive);
      });
    };

    $rootScope.consumeNotifications = (consumeNotificationCallback, id) => {
      // show modal if we are in "Carica documento Step2" and we click on notification
      let currentStateIsConservazioneCaricaStep2 = $rootScope.checkIfConservazioneCaricaStep2();
      if (currentStateIsConservazioneCaricaStep2) {
        let modalInstance = $uibModal.open({
          animation: true,
          component: 'defaultModalComponent',
          windowClass: 'center-modal',
          resolve: {
            config: () => {
              let conservazioneClasseDocumentale: string = store.get('conservazioneClasseDocumentale').label;
              return {
                headerIcon: 'fa fa-exclamation-triangle',
                headerText: 'Attenzione',
                bodyHtml: `
                                    Desideri interrompere l'operazione di Conservazione ${conservazioneClasseDocumentale}?
                                    <br/> <br/>Attenzione! Interrompendo questa procedura tutti i dati temporanei verranno cancellati.
                                    <br/><br/>
                                    Se selezioni <b>Si</b>, confermi l'uscita dalla procedura e annulli l'operazione in corso, <b>No</b> per proseguire con la Conservazione.`,
                buttons: [
                  {
                    'id': 1,
                    'icon': 'fa fa-times-circle-o',
                    'label': 'No'
                  },
                  {
                    'id': 2,
                    'icon': 'fa fa-check-circle-o',
                    'label': 'Si'
                  }
                ]
              };
            }
          }
        });

        modalInstance.result.then((pressedButtonId) => {
          if (pressedButtonId === 1) {
            return;
          } else if (pressedButtonId === 2) {
            $rootScope.removeConservazioneSettingsFiles(store.get('conservazioneClasseDocumentale').value);
            $timeout(() => {
              store.remove('conservazioneClasseDocumentale');
              id === undefined ? consumeNotificationCallback() : consumeNotificationCallback(id);
            });
          }
        });
      } else {
        id === undefined ? consumeNotificationCallback() : consumeNotificationCallback(id);
      }
    };

    $rootScope.ArchiDriveNotificationCount = 0;
    $rootScope.navigateToArchiDrive = () => {

      let consumeArchidriveNotifications = () => {
        $rootScope.ArchiDriveNotificationCount = 0;

        let count = $rootScope.userNotifications.length;
        let notificationsIdsArray = [];
        for (let i = 0; i < $rootScope.userNotifications.length; i++) {
          if ($rootScope.userNotifications[i].type === 'archidrive') {
            notificationsIdsArray.push($rootScope.userNotifications[i]._id);
            $rootScope.userNotifications.splice(i, 1);
            i--;
          }
        }
        ArchiSmallServices.notificationConsume(notificationsIdsArray)
          .then((response) => { /* */
          }, (error) => {
            $rootScope.alert('error', error);
          });
        $state.go('home.archidrive', {file: ''});

        if ($state.current.name === 'home.archidrive') {
          $state.transitionTo('home.archidrive', {file: ''}, {reload: true});
        }
      };

      $rootScope.consumeNotifications(consumeArchidriveNotifications);
    };

    $rootScope.consumeUserNotifications = (id) => {
      // operation to do in case a notifications is accessed
      let consumeUserNotification = (id) => {
        // identify the notification
        let indexes = $.map($rootScope.userNotifications, (obj, index) => {
          if (obj._id === id) {
            return index;
          }
        });
        if (indexes.length !== 1) {
          return;
        }
        // mark notification as consumed
        let notificationIdArr = [];
        notificationIdArr.push($rootScope.userNotifications[indexes[0]]._id);
        ArchiSmallServices.notificationConsume(notificationIdArr)
          .then((response) => {
            // when notification is succesfully updated proceed with notification consumtion
            switch ($rootScope.userNotifications[indexes[0]].type) {
              case 'archidrive':
                if ($rootScope.ArchiDriveNotificationCount > 0) {
                  $rootScope.ArchiDriveNotificationCount--;
                }
                $state.go('home.archidrive', {file: $rootScope.userNotifications[indexes[0]].document.DIP.FileName});
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
              case 'conservato':
                $state.go('home.conservazione-consulta-documenti', {
                  classeDocumentale: $rootScope.userNotifications[indexes[0]].document.Oggetto,
                  id: $rootScope.userNotifications[indexes[0]].document._id
                });
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
              case 'archidrive-multiple':
                if ($rootScope.ArchiDriveNotificationCount > 0) {
                  $rootScope.ArchiDriveNotificationCount--;
                }
                $state.go('home.archidrive', {file: $rootScope.userNotifications[indexes[0]].document.DIP.FileName});
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
              case 'conservazione':
                store.set('ConservazioneCaricaDocumento-Result', $rootScope.userNotifications[indexes[0]].details);
                if ($state.current.name !== 'home.conservazione-carica-documento-step3') {
                  $state.go('home.conservazione-carica-documento-step3');
                } else {
                  $state.transitionTo('home.conservazione-carica-documento-step3', $state.current.params, {reload: true});
                }
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
              case 'conservazione-fatture-attive-versamento':
              case 'conservazione-pec-versamento':
                store.set('ConservazioneVersamento-Result', $rootScope.userNotifications[indexes[0]].details);
                if ($state.current.name !== 'home.conservazione-versamento-result') {
                  $state.go('home.conservazione-versamento-result');
                } else {
                  $state.transitionTo('home.conservazione-versamento-result', $state.current.params, {reload: true});
                }
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
              case 'conservazione-fatture-attive':
                store.set('ConservazioneCaricaDocumento-Result', $rootScope.userNotifications[indexes[0]].details);
                if ($state.current.name !== 'home.conservazione-carica-documento-step3') {
                  $state.go('home.conservazione-carica-documento-step3');
                } else {
                  $state.transitionTo('home.conservazione-carica-documento-step3', $state.current.params, {reload: true});
                }
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
              case 'conservazione-fatture-pa-e-notifiche':
              case 'conservazione-fattura-gse-e-notifiche':
                store.set('ConservazioneCaricaDocumento-Result', $rootScope.userNotifications[indexes[0]].details);
                let _classeDocumentale = $rootScope.userNotifications[indexes[0]].details.messageResult.classeDocumentale;
                if ($state.current.name !== 'home.conservazione-carica-fattura-elettronica-attiva') {
                  $state.go('home.conservazione-carica-fattura-elettronica-attiva', {classeDocumentale: _classeDocumentale});
                } else {
                  $state.transitionTo('home.conservazione-carica-fattura-elettronica-attiva', {classeDocumentale: _classeDocumentale}, {reload: true});
                }
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
              case 'conservazione-fatture-elettronica-passiva':
                store.set('ConservazioneCaricaDocumento-Result', $rootScope.userNotifications[indexes[0]].details);
                let __classeDocumentale = $rootScope.userNotifications[indexes[0]].details.messageResult.classeDocumentale;
                if ($state.current.name !== 'home.conservazione-carica-fattura-elettronica-passiva') {
                  $state.go('home.conservazione-carica-fattura-elettronica-passiva', {classeDocumentale: __classeDocumentale});
                } else {
                  $state.transitionTo('home.conservazione-carica-fattura-elettronica-passiva', {classeDocumentale: __classeDocumentale}, {reload: true});
                }
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
              case 'conservazione-pec':
                store.set('ConservazioneCaricaDocumento-Result', $rootScope.userNotifications[indexes[0]].details);
                if ($state.current.name !== 'home.conservazione-carica-mail-pec-summary') {
                  $state.go('home.conservazione-carica-mail-pec-summary');
                } else {
                  $state.transitionTo('home.conservazione-carica-mail-pec-summary', $state.current.params, {reload: true});
                }
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
              case 'conservazione-fatture-attive-enabled':
                if ($rootScope.userNotifications[indexes[0]].status === 1) {

                  if ($state.current.name !== 'home.conservazione-carica-documento-step1') {
                    $state.go('home.conservazione-carica-documento-step1', {classeDocumentale: 'fatture-attive'});
                  } else {
                    $state.transitionTo('home.conservazione-carica-documento-step1', {classeDocumentale: 'fatture-attive'}, {reload: true});
                  }
                  $rootScope.userNotifications.splice(indexes[0], 1);
                }
                break;
              case 'fattura-pa-status':
                let numeroFattura = $rootScope.userNotifications[indexes[0]].fattura_number;
                if ($state.current.name !== 'home.pa-visualizza-stato-fatture') {
                  $state.go('home.pa-visualizza-stato-fatture', {numeroFattura: numeroFattura});
                } else {
                  $state.transitionTo('home.pa-visualizza-stato-fatture', {numeroFattura: numeroFattura}, {reload: true});
                }
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
              case 'fattura-pr-status':
                let _numeroFattura = $rootScope.userNotifications[indexes[0]].fattura_number;
                if ($state.current.name !== 'home.visualizza-stato-fatture-pr') {
                  $state.go('home.visualizza-stato-fatture-pr', {numeroFattura: _numeroFattura});
                } else {
                  $state.transitionTo('home.visualizza-stato-fatture-pr', {numeroFattura: _numeroFattura}, {reload: true});
                }
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
              case 'fattura-passiva-status':
                let _status = 'Ricevuta';
                if ($state.current.name !== 'home.pr-fattura-elettronica-passiva') {
                  $state.go('home.pr-fattura-elettronica-passiva', {status: _status});
                } else {
                  $state.transitionTo('home.pr-fattura-elettronica-passiva', {status: _status}, {reload: true});
                }
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
              case 'azienda_tdoc':
                store.set('WorkerAnagraficaInTdoc-Result', $rootScope.userNotifications[indexes[0]].details);
                if ($state.current.name !== 'home.worker-anagrafica-in-tdoc-result') {
                  $state.go('home.worker-anagrafica-in-tdoc-result');
                } else {
                  $state.transitionTo('home.worker-anagrafica-in-tdoc-result', $state.current.params, {reload: true});
                }
                $rootScope.userNotifications.splice(indexes[0], 1);
                break;
            }
          }, (error) => {
            $rootScope.alert('error', error);
          });
      };

      $rootScope.consumeNotifications(consumeUserNotification, id);

    };
    $rootScope.userNotifications = [];
    let notificationSubscriber = (message, dontCallApply) => {
      if ($rootScope.disabledNotification) {
        return;
      }
      let userNotification = JSON.parse(message.body);
      switch (userNotification.type) {
        case 'archidrive':
          $rootScope.ArchiDriveNotificationCount++;
          if (
            [
              'home.conservazione-consulta-documenti',
              'home.conservazione-pacchetti-archiviazione'
            ].indexOf($state.current.name) > -1) {
            $rootScope.conservazioneNotification.updateDocument(userNotification.document);
          }
          break;
        case 'conservato':
          if ($state.current.name === 'home.conservazione-consulta-documenti') {
            $rootScope.conservazioneNotification.updateDocument(userNotification.document);
          }
          break;
        case 'archidrive-multiple':
          $rootScope.ArchiDriveNotificationCount++;
          break;
        case 'conservazione':
        case 'conservazione-fatture-attive':
        case 'conservazione-fatture-attive-versamento':
        case 'conservazione-fatture-pa-e-notifiche':
        case 'conservazione-fattura-gse-e-notifiche':
        case 'conservazione-pec':
        case 'conservazione-pec-versamento':
        case 'fattura-pa-status':
        case 'conservazione-fatture-elettronica-passiva':
        case 'azienda_tdoc':

          // in case workerSubscriberActiveQueue is current one we skip it
          if (typeof $rootScope.workerSubscriberActiveQueue !== undefined &&
            $rootScope.workerSubscriberActiveQueue === userNotification.queueName) {
            // mark notification as consumed
            let notificationIdArr = [];
            notificationIdArr.push(userNotification._id);
            ArchiSmallServices.notificationConsume(notificationIdArr)
              .then((response) => { /* */
              }, (error) => {
                $rootScope.alert('error', error);
              });
            return;
          }
          break;
        case 'conservazione-fatture-attive-enabled':
          ArchiSmallServices.getUser($rootScope.currentUser().sub)
            .then((response) => {
              $rootScope.user = response;
              store.set('user', response);
            }, (error) => {
              $rootScope.alert('error', error);
            });
        // todo: e` strano che qui non ci sia un break o un return
        /* falls through */
        case 'active-connection':
          console.log(userNotification);
          if (userNotification.activeConnectionID !== $rootScope.activeConnectionID) {
            if ($rootScope.subscriptionNotificationWorker !== undefined) {
              $rootScope.subscriptionNotificationWorker.unsubscribe();
              $rootScope.subscriptionNotificationWorker = undefined;
              $rootScope.userNotifications = [];
              $rootScope.ArchiDriveNotificationCount = 0;
            }
            let resumeApplicationModal = $uibModal.open({
              animation: true,
              component: 'resumeApplicationModalComponent',
              windowClass: 'center-modal',
              backdrop: 'static',
              keyboard: false,
              resolve: {}
            });
          }
          return;
        case 'subscription-cancelled':
          $rootScope.subscriptionCancelled = userNotification.isSubscriptionCancelled;
          if ($rootScope.subscriptionCancelled) {
            $state.go('unsubscription.unsubscription-index');
          }
          return;
        case 'subscription-expired':
          $rootScope.subscriptionExpired = userNotification.subscriptionIsExpired;
          if ($rootScope.subscriptionExpired) {
            $state.go('unsubscription.abbonamento-disdetto');
          }
          return;

        case 'unsubscription-archives':
          if (userNotification.unsubscriptionArchiveIsAdded) {
            let archiveExists: any = null;
            if (userNotification.unsubscriptionArchive.type === 1 && $state.current.name === 'unsubscription.scarica-archivio') {
              let isArchiveArrayGreaterThanZero = $rootScope.archidriveArchives.length > 0;
              if (isArchiveArrayGreaterThanZero) {
                archiveExists = $rootScope.checkIfArchiveExists(userNotification.unsubscriptionArchive, 'archidriveArchives');
              }
              if (!isArchiveArrayGreaterThanZero || !archiveExists) {
                $rootScope.addArchive(userNotification.unsubscriptionArchive, 'archidriveArchives');
              }
            } else if (userNotification.unsubscriptionArchive.type === 2 && $state.current.name === 'unsubscription.scarica-documenti-conservati') {
              let isArchiveArrayGreaterThanZero = $rootScope.conservazioneArchives.length > 0;
              if (isArchiveArrayGreaterThanZero) {
                archiveExists = $rootScope.checkIfArchiveExists(userNotification.unsubscriptionArchive, 'conservazioneArchives');
              }
              if (!isArchiveArrayGreaterThanZero || !archiveExists) {
                $rootScope.addArchive(userNotification.unsubscriptionArchive, 'conservazioneArchives');
              }
            }
          }
          return;
        default:
          break;
      }
      $timeout(() => $rootScope.userNotifications.unshift(userNotification), 0, true);
      let notificationLengthString = $rootScope.userNotifications.length > 0 ? '(' + $rootScope.userNotifications.length + ') ' : '';
    };
    $rootScope.startNotificationWorker = () => {
      try {
        $rootScope.disabledNotification = $rootScope.user.isNotificationsDisabled;
        // if ($rootScope.subscriptionNotificationWorker !== undefined) {
        //   return 1;
        // }
        let firstRun = true;
        let i = 1;
        let startWorker = () => {
          // console.log(rabbitMQ, rabbitMQ.client.STATE, !$rootScope.disabledNotification);
          if (!$rootScope.disabledNotification) {
            let email = $rootScope.user.accountData.email;

            ArchiSmallServices.notifications(email)
              .then((response: any) => {
                // per evitare il flash fastidioso sul badge delle notifiche, vengono aggiornate solamente se gli oggetti in arrivo sono diversi da quelli presenti
                if (firstRun
                  || !(
                    $rootScope.userNotifications.every(item => response.resultList.some(obj => JSON.stringify(diff(JSON.parse(obj.message), item)) === '{}'))
                    && response.resultList.every(item => $rootScope.userNotifications.some(obj => JSON.stringify(diff(obj, JSON.parse(item.message))) === '{}'))
                  )
                ) {
                  $rootScope.userNotifications = [];
                  firstRun = false;

                  for (let i = 0; i < response.resultList.length; i++) {
                    let message = {body: response.resultList[i].message};
                    notificationSubscriber(message, true);
                  }
                }
              });
          }
        };
        // la prima chiamata per evitare di avere il box vuoto per i primi 5 secondi
        startWorker();
        // let intervalPromise = $interval(startWorker, 25000);
        // $scope.$on('$destroy', () => {
        //   $interval.cancel(intervalPromise);
        //   intervalPromise = undefined;
        // });
        // startWorker();
        // $timeout(startWorker, 1000);
      } catch (err) {
        return 0;
      }
      return 1;
    };

    $rootScope.gotoNotificationsPage = () => {
      $state.go('home.notifiche');
    };

    $rootScope.clearNotifications = () => {
      // mark notifications as consumed
      let notificationIdArr = [];
      for (let i = 0; i < $rootScope.userNotifications.length; i++) {
        notificationIdArr.push($rootScope.userNotifications[i]._id);
      }
      ArchiSmallServices.notificationConsume(notificationIdArr)
        .then((response) => {
          $rootScope.userNotifications = [];
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };

    $rootScope.toggleNotificationDisplay = () => {
      $rootScope.disabledNotification = !$rootScope.disabledNotification;
      if ($rootScope.disabledNotification) {
        $rootScope.user.isNotificationsDisabled = true;
      } else {
        $rootScope.user.isNotificationsDisabled = false;
        $rootScope.startNotificationWorker();
      }
      ArchiSmallServices.updateNotificiationsDisabled($rootScope.user)
        .then((response) => {
          console.log('Updated user');
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };

    $rootScope.clearNotificationsAll = () => {
      $rootScope.userNotifications = [];
      ArchiSmallServices.notificationConsumeAll()
        .then((response) => {
          $rootScope.userNotifications = [];
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };

    $rootScope.formatDecimal = (input: any, decimals: any) => {
      if (input !== undefined) {
        if (typeof input === 'string') {
          input = input.replace(',', '.');
        }
        let exponent = Math.pow(10, decimals);
        let int: number = Math.round(input * exponent) / exponent;
        let res: string = int.toFixed(decimals);
        // keep only 2 decimal if are diff then 0
        if (decimals > 2 && res.indexOf('.') > -1) {
          let splits = res.split('.');
          if (splits.length === 2) {
            let decimalsPart = splits[1];
            for (let i = splits[1].length - 1; i >= 2; i--) {
              if (splits[1][i] === '0') {
                decimalsPart = decimalsPart.substring(0, decimalsPart.length - 1);
              } else {
                break;
              }
            }
            res = splits[0] + '.' + decimalsPart;
          }
        }
        return isNaN(res as any) ? '0.00' : res;
      }
    };
    $rootScope.amount2DecimalTypePattern = (() => {
      let regexp = new RegExp('^[\-]?[0-9]{1,11}\\.[0-9]{2}$');
      return {
        test: (value) => {
          let formattedValue = $rootScope.formatDecimal(value, 2);
          return regexp.test(formattedValue);
        }
      };
    })();
    $rootScope.amount8DecimalTypePattern = (() => {
      let regexp = new RegExp('^[\-]?[0-9]{1,11}\\.[0-9]{2,8}$');
      return {
        test: (value) => {
          let formattedValue = $rootScope.formatDecimal(value, 8);
          return regexp.test(formattedValue);
        }
      };
    })();
    $rootScope.quantitaTypePattern = (() => {
      let regexp = new RegExp('^[0-9]{1,12}\\.[0-9]{2,8}$');
      return {
        test: (value) => {
          let formattedValue = $rootScope.formatDecimal(value, 8);
          return regexp.test(formattedValue);
        }
      };
    })();
    $rootScope.rateTypePattern = (() => {
      let regexp = new RegExp('^[0-9]{1,3}\\.[0-9]{2}$');
      return {
        test: (value) => {
          let formattedValue = $rootScope.formatDecimal(value, 2);
          try {
            if (parseFloat(formattedValue) > 100) {
              return false;
            }
          } catch (ex) { /* */
          }

          return regexp.test(formattedValue);
        }
      };
    })();
    $rootScope.pesoTypePattern = (() => {
      let regexp = new RegExp('^[0-9]{1,4}\\.[0-9]{1,2}$');
      return {
        test: (value) => {
          let formattedValue = $rootScope.formatDecimal(value, 2);
          return regexp.test(formattedValue);
        }
      };
    })();

    $rootScope.alert = (type, message) => {
      this.alertService.alert(type, message);
    };

    $rootScope.setErrorFieldsTouched = (errors) => {
      this.formService.setErrorFieldsTouched(errors);
    };

    $rootScope.tryMethod = (errors, callback, aditionalCondition) => {
      this.formService.tryMethod(errors, callback, aditionalCondition);
    };

    $rootScope.setAnotherValue = (values, search) => {
      if (values !== undefined) {
        let newValue = values.slice();
        if (search && newValue.indexOf(search) === -1) {
          newValue.unshift(search);
        }
        return newValue;
      }
    };
    $rootScope.setAnotherValueObjects = (values, searchObj) => {

      if (values !== undefined) {

        let searchKeys = Object.keys(searchObj);

        let allPorpertiesAreEmpty = true;
        for (let i = 0; i < searchKeys.length; i++) {

          if (searchObj[searchKeys[i]] !== '') {
            allPorpertiesAreEmpty = false;
            break;
          }
        }

        if (allPorpertiesAreEmpty) {
          return values;
        }
        // search the item
        let searchRes = values.filter((obj) => {
          let found = true;
          for (let i = 0; i < searchKeys.length; i++) {
            let prop = searchKeys[i];
            let text = searchObj[prop].toLowerCase();
            if (obj[prop].toString().toLowerCase() !== text) {
              found = false;
              break;
            }
          }
          return found;
        });

        // if item is not present we add it
        if (searchRes.length === 0) {
          // if fake object  is already present we update it
          // fake object can be only on first position
          if (values[0] && values[0].fake) {
            for (let i = 0; i < searchKeys.length; i++) {
              values[0][searchKeys[i]] = searchObj[searchKeys[i]];
            }
          } else {
            searchObj.fake = true;
            values.unshift(searchObj);
          }
        }
        return values;
      }
    };
    $rootScope.formatFilename = (filename, max) => {
      if (filename === undefined) {
        return '';
      } else {
        let filenameLength = filename.length;
        if (filename.replace(' ', '').length > (max + 3)) {
          return filename.substr(0, Math.floor(max / 2)).trim() + '...' + filename.substr(filenameLength - Math.floor(max / 2), filenameLength).trim();
        }
        return filename;
      }
    };
    $rootScope.ArchiSmallERRORS = new ArchiSmallERRORS();
    $rootScope.DocumentStatus = DocumentStatus;
    /* tslint:disable:no-string-literal */
    $rootScope.downloadFileRDVXml = (result) => {
      let _string = `<?xml version="1.0" encoding="UTF-8"?>'
                        \r\n<RDV url="https://www.archismall.com/RDV_Schema">
                        \r\n     <SelfDescription>
                        \r\n         <ID>${result.RDV.SelfDescription.ID}</ID>
                        \r\n         <CreatingApplication>
                        \r\n             <Name>ArchiSMALL</Name>
                        \r\n             <Version>${configuration.archiSmallAppVersion}</Version>
                        \r\n             <Producer>Archivist SRL</Producer>
                        \r\n         </CreatingApplication>
                        \r\n     </SelfDescription>
                        \r\n     <RapportoDiVersamento>
                        \r\n         <Esito>POSITIVO</Esito>
                        \r\n         <DescrizioneEsito>Controlli formato e metadata positivi - Pacchetto Versato al Sistema di Conservazione</DescrizioneEsito>
                        \r\n     </RapportoDiVersamento>
                        \r\n     <FileGroup>
                        \r\n         <File>
                        \r\n             <ID>${result.RDV.FileGroup.File.ID}</ID>
                        \r\n             <Path>${result.RDV.FileGroup.File.Path}</Path>
                        \r\n             <Hash function="SHA-256">${result.RDV.FileGroup.File.Hash}</Hash>
                        \r\n         </File>
                        \r\n     </FileGroup>
                        \r\n     <TimeReference>
                        \r\n         <TimeInfo normal="+01">${result.RDV.TimeReference.TimeInfo}</TimeInfo>
                        \r\n     </TimeReference>
                        \r\n</RDV>`;
      let blob = new Blob([_string], {type: 'text/xml'});
      let name = `RDV_${result.RDV.FileGroup.File.ID}.xml`;
      if (appContext.userBrowser['isIE']) {
        navigator.msSaveBlob(blob, name);
      } else {
        if (saveAs) {
          saveAs(blob, name);
        } else {
          navigator.msSaveBlob(blob, name);
        }
      }
    };

    $rootScope.showConsumi = (typeLimit: string) => {

      ArchiSmallServices.getStorageUsage()
        .then((response) => {
          $rootScope.storageUsage = response;
          if (typeLimit === 'CE') {
            $scope.typeLimit = typeLimit;
            $rootScope.storageUsage.dataSize.splice(0, 2);
            $rootScope.storageUsage.data.splice(0, 2);
            $rootScope.storageUsage.labels = ['Conservazione', 'Archivia', 'Spazio Libero'];
            for (let i = 0; i < $rootScope.storageUsage.labels.length; i++) {
              $rootScope.storageUsage.labels[i] += ` ${$rootScope.storageUsage.dataSize[i]} MB`;
            }
            $rootScope.storageUsage.colours = ['#F8A37E', '#818286', '#FFFFFF'];
          }
          if (typeLimit === 'PEC') {
            $scope.typeLimit = typeLimit;
            $rootScope.storageUsage.dataSize.splice(2, 3);
            $rootScope.storageUsage.data.splice(2, 3);
            $rootScope.storageUsage.labels = ['PEC', 'Spazio Libero'];
            for (let i = 0; i < $rootScope.storageUsage.labels.length; i++) {
              $rootScope.storageUsage.labels[i] += ` ${$rootScope.storageUsage.dataSize[i]} MB`;
            }
            $rootScope.storageUsage.colours = ['#00A400', '#FFFFFF'];
          }
          $uibModal.open({
            animation: true,
            component: 'consumiModalComponent',
            windowClass: 'center-modal consumi-modal',
            size: 'md-710',
            resolve: {
              settings: {
                typeLimit: $scope.typeLimit,
              }
            }
          });
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };

    $rootScope.showConsumiFE = () => {

      ArchiSmallServices.getStorageUsageFe()
        .then((response) => {
          $rootScope.storageUsage = response;
          $rootScope.storageUsage.labels = ['Fatture Inviate', 'Fatture Ricevute', 'Fatture rimanenti da profilo'];
          for (let i = 0; i < $rootScope.storageUsage.labels.length; i++) {
            $rootScope.storageUsage.labels[i] += ` (${$rootScope.storageUsage.dataSize[i]}) Invoices`;
          }
          $rootScope.storageUsage.colours = ['#EF4723', '#F8A37E', '#FFFFFF'];
          $uibModal.open({
            animation: true,
            component: 'consumiFeModalComponent',
            windowClass: 'center-modal consumi-modal',
            size: 'md-710',
            resolve: {}
          });
        }, (error) => {
          $rootScope.alert('error', error);
        });
    };

    $rootScope.notifyActiveConnection = () => {
      $rootScope.activeConnectionID = $rootScope.activeConnectionID || $rootScope.guid();
      let settings = {
        'activeConnectionID': $rootScope.activeConnectionID,
        'type': 'active-connection',
      };
      rabbitMQ.send('notifications_' + $rootScope.currentUser().sub, JSON.stringify(settings), false);
      setTimeout(() => {
        ArchiSmallServices.getConnectionCount()
          .then((response: any) => {
            if (response.connectionCount > 1) {
              // $rootScope.notifyActiveConnection();
            }
          });
      }, 4000);
    };
    // 'WS retry' management
    $rootScope.WSRequestsCounter = new Array();
    $rootScope.ArchiSmallServices = ArchiSmallServices;
    $rootScope.disabledNotification = false;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/app.controller.ts